import React, { useReducer } from 'react';
import { Reducer as reducer } from './Reducer';
import { Actions as actions } from './Actions';

const initialValue = {
  payments: null,
  affiliateId: null,
};

const context = React.createContext();

function Context({ children, affiliateId }) {
  initialValue.affiliateId = affiliateId;
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <context.Provider value={{ state, dispatch, actions }}>
      {children}
    </context.Provider>
  );
}

export const useContext = () => React.useContext(context);
export default Context;
